import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    minWidth: 0,
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  textarea: {
    width: "100%",
    direction: "ltr",
    "& .MuiOutlinedInput-root": {
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: 0,
      textAlign: "right",
      verticalAlign: "middle",
      color: theme.palette.secondary.main,
      leadingTrim: "cap-height",
      backgroundColor: theme.palette.background.paper,
      borderRadius: "4px",
      direction: "ltr",
      alignItems: "flex-start",
      padding: 0,
      height: "274px",
      "& fieldset": {
        borderColor: theme.palette.divider,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.divider,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: 0,
      textAlign: "right",
      verticalAlign: "middle",
      color: theme.palette.secondary.main,
      leadingTrim: "cap-height",
      padding: "10px",
      direction: "rtl",
      height: "274px !important",
      boxSizing: "border-box",
      fontFamily: "Noto Sans Hebrew",
    },
    "& .MuiInputBase-inputMultiline": {
      padding: "10px",
      height: "274px !important",
    },
    "& textarea": {
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: 0,
      textAlign: "right",
      verticalAlign: "middle",
      color: theme.palette.secondary.main,
      leadingTrim: "cap-height",
      direction: "rtl",
      height: "274px !important",
      overflow: "auto !important",
      resize: "none",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      fontFamily: "Noto Sans Hebrew",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    "& textarea::placeholder": {
      textAlign: "right",
      opacity: 1,
      color: theme.palette.text.secondary,
    },
  },
  addButton: {
    width: "100%",
    height: "48px",
    minHeight: "48px",
    borderRadius: "4px",
    padding: "10px 16px",
    gap: "6px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    boxSizing: "border-box",
    fontFamily: "Noto Sans Hebrew",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
  },
  divider: {
    height: "1px",
    backgroundColor: theme.palette.divider,
  },
  historyTitle: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  historyList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  historyItem: {
    backgroundColor: theme.palette.grey[400],
    borderRadius: "4px",
    padding: "12px 16px",
    height: "56px",
    minHeight: "56px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "2px",
    direction: "ltr",
  },
  historyMeta: {
    fontSize: "12px",
    lineHeight: "18px",
    color: theme.palette.text.secondary,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  historyContent: {
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
}));
